const size = {
 phone: "320px",
 tablet: "768px",
 pc: "1200px",
 laptop: "1320px",
}
const device = {
 phone: `(max-width: ${size.phone})`,
 tablet: `(max-width: ${size.tablet})`,
 pc: `(max-width: ${size.pc})`,
 laptop: `(max-width: ${size.laptop})`
}

const sd = {size, device}

export default sd;

/*
    import brk from '../../util/breakpoints';
    @media ${brk.device.phone}{
        display: none;
    }
*/